import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PermissionGuard } from '../shared/guards/permission-guard';
import { VersionGuard } from '../shared/guards/version-guard';

import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { AccountComponent } from './account.component';
import { PermissionLevel } from '../shared/permission/permission';
import { RoutePaths } from '../shared/navigation/route-paths';

const accountRoutes: Array<DynamicRoute> = [
  {
    path: RoutePaths.NEW_ACCOUNT,
    component: AccountComponent,
    canActivate: [VersionGuard, PermissionGuard],
    data: {
      permissionLevel: PermissionLevel.MANAGER
    }
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(accountRoutes)]
})
export class NewAccountRoutingModule {}
